import { Enum } from "./Enum";

export const E_ASSETS = Object.freeze({
  IMAGE: "/asset/image",
});

export type E_ASSETS = Enum<typeof E_ASSETS>;
